import { centeredContent } from 'shared/theme/mixins'
import styled from 'styled-components'

export const DriverApplicationContainer = styled.div`
  ${centeredContent};
  flex-direction: column;
  margin: 0 auto;
  max-width: 648px;
`

export const DriverApplicationContent = styled.div`
  ${centeredContent};
  flex-direction: column;
  max-width: 424px;
  width: 100%;
  margin: 0 auto;
`
